import { useContext, useMemo } from 'react'
import { Agent } from '@atproto/api'
import { AppViewContext } from '@/contexts/AppViewContext/AppViewContext'
import { useAuth } from '@/hooks/useAuth'

export function useAppView() {
    const context = useContext(AppViewContext)
    if (!context) {
        throw new Error('useAppView must be used within an AppViewProvider')
    }
    const { session } = useAuth()

    // Proxy-aware session agent for authenticated reads. When a non-default AppView is
    // selected, attaches atproto-proxy header so the PDS forwards via service auth.
    // Writes must still use new Agent(session) directly — no proxy.
    const sessionAgent = useMemo(() => {
        if (!session) return null
        const base = new Agent(session)
        return context.appViewDid ? base.withProxy('bsky_appview', context.appViewDid) : base
    }, [session, context.appViewDid])

    return { ...context, sessionAgent }
}
